import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Offend/ExploitPack/ExploitPack.tsx");
